import React from "react";
import cx from "classnames";
import { Reveal } from "src/components/reveal";
import { Image } from "src/components/image";
import { BlockContent } from "src/components/block-content";
import { CTA } from "src/components/cta";
import { BackgroundLines } from "src/components/background-lines";

import styles from "./banner.module.css";

interface BannerProps {
  module: {
    copyAlignment?: string;
    copyColor?: string;
    label?: string;
    headline?: string;
    copy?: any;
    cta?: any;
    image: any;
    mobileImage?: any;
    backgroundLines?: {
      type: string;
      color: string;
      alignment: string;
    };
  };
}
export const Banner = ({ module }: BannerProps) => {
  const {
    copyAlignment,
    copyColor = "wine",
    label,
    headline,
    copy,
    cta,
    image,
    mobileImage,
    backgroundLines
  } = module;
  return (
    <section
      className={cx(
        styles.banner,
        copyAlignment === "right" ? styles.alignRight : styles.alignLeft,
        mobileImage ? styles.hasMobileImage : ""
      )}
    >
      {backgroundLines && (
        <BackgroundLines
          type={backgroundLines.type}
          color={backgroundLines.color}
          alignment={backgroundLines.alignment}
        />
      )}
      <div className={styles.imageWrapper}>
        {image && (
          <Image
            className={styles.image}
            imageId={image.asset._id}
            width={2400}
            alt={image.alt ? image.alt : ""}
            style={{ height: "100%" }}
            objectPosition="100% 50%"
          />
        )}
        {mobileImage && (
          <Image
            className={styles.mobileImage}
            imageId={mobileImage.asset._id}
            width={600}
            style={{ height: "100%" }}
            objectPosition="50% 50%"
            alt={image.alt ? image.alt : ""}
          />
        )}
      </div>
      <div className={styles.bannerInner}>
        <div className={styles.copyColumn}>
          <div className={cx(`c-${copyColor}`, styles.copyColumnInner)}>
            <Reveal>
              {label && (
                <h4 className={cx("small-caps-13", styles.label)}>{label}</h4>
              )}
              {headline && <h2 className={cx("headline")}>{headline}</h2>}
              {copy && <BlockContent className={styles.copy} blocks={copy} />}
              {cta && (
                <CTA
                  className={styles.cta}
                  cta={cta}
                  style="stroke"
                  color={copyColor === "white" ? "white" : "terracotta"}
                />
              )}
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
